<template>
  <div class="form-check form-switch mb-0">
    <input
      class="form-check-input"
      type="checkbox"
      value="1"
      id="cash_mount_checkbox"
      @change="cashMountCheck($event)"
      :checked="$store.state.cash_mount_checked"
    />
    <label class="form-check-label" for="cash_mount_checkbox">Montaria</label>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "CashMountCheckbox",
  methods: {
    ...mapMutations(["SAVE_CASH_MOUNT"]),
    cashMountCheck: function (event) {
      this.SAVE_CASH_MOUNT(event.target.checked);
    },
  },
};
</script>
